// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { Bug as RawBug } from "lucide-react";
export const Bug = /* @__PURE__ */ createIcon(RawBug, "Bug", 2);
